// Layout
import SubsReportLayout from './pages/SubsReportLayout'

// Pages
import SubsReportList from './pages/list/SubsReportList'


export default {
  path: 'subscribers-report',
  name: 'subscribers-report',
  component: SubsReportLayout,
  redirect: {
    name: 'subscribers-report-list'
  },
  children: [
    {
      path: 'list',
      name: 'subscribers-report-list',
      component: SubsReportList
    },
  ]
}